class TopContentManager {
    constructor() {
        this.steelCategorySet = {};
        this.init();
    }

    async init() {
        this.steelCategorySet = await tentecoAPI.getSteelCategorySet();
        this.renderShapeButtons();
        this.adjustRecommendProductsHeight();
        this.setEvent();
    }

    /* イベント
    -------------------------------------------------------- */
    setEvent() {
        this.bindTabSwitchingEvents();
        this.bindShapeButtonEvents();
        this.submitKeywordSearch();
        $(window).on("resize", () => {
            this.adjustRecommendProductsHeight();
        });
    }

    // タブ切り替えイベント
    bindTabSwitchingEvents() {
        $(document).on('click', '.tab-nav .tab-button', (e) => {
            const $this = $(e.currentTarget);
            const $tabNav = $this.closest('.tab-nav');
            const $tabButtons = $tabNav.find('.tab-button');
            const targetTab = $this.attr('data-tab');
            const tabGroup = $this.attr('data-tab-group');

            // 同じグループ内のタブボタンからactiveクラスを削除
            $tabButtons.removeClass('active');

            // 同じグループ内のタブコンテンツからactiveクラスを削除
            const $tabContents = $tabNav.next('.tab-contents').find('.tab-content');
            $tabContents.removeClass('active');

            // クリックされたタブボタンにactiveクラスを追加
            $this.addClass('active');

            // 対応するタブコンテンツにactiveクラスを追加
            $('#' + targetTab).addClass('active');

            // 品種から探すタブに戻った時、品種を規定値に戻す
            if (targetTab === 'search-cond') {
                this.selectFirstShapeContent();
                this.resetActiveShapeContent();
            }

            // 品種を切り替えた際、形状と鋼種を規定値に戻す
            if(tabGroup === 'shape'){
                this.resetActiveShapeContent();
            }
        });
    }

    // 「品種から探す」変更時のイベント
    bindShapeButtonEvents() {
        // 形状・鋼種ボタンのクリックイベント
        $(document).on('click', '.shape-box--btn', (e) => {
            // activeクラスの付け替え
            const $buttonGroup = $(e.currentTarget).closest('.shape-box--btn-group');
            if ($buttonGroup.length) {
                $buttonGroup.find('.shape-box--btn').removeClass('active');
            }
            $(e.currentTarget).addClass('active');

            // 隠しパラメータを更新
            this.updCondSearchHiddenParams();
        });

        // 品種切り替え
        $(document).on('click', '.tab-button__steel-variety', (e) => {
            // 隠しパラメータを更新
            this.updCondSearchHiddenParams();
        });

        // 鋼種切り替え
        $(document).on('click', '.shape-box--btn__steel-type', (e) => {
            this.selectSteelType($(e.currentTarget));
        });
    }

    // キーワード検索フォーム送信
    submitKeywordSearch() {
        const $keywordForm = $('#search-keyword .main-form-search');
        $keywordForm.on('submit', (e) => {
            e.preventDefault();
            
            const $searchInput = $('#Search-In-Template-Keyword');
            const $hiddenQInput = $('#search-keyword input[name="q"]');
            
            if ($searchInput.length && $hiddenQInput.length) {
                $hiddenQInput.val($searchInput.val().trim() || '#');
                $keywordForm[0].submit();
            }
        });
    }

    /* 「品種から探す」
    -------------------------------------------------------- */
    // 「品種から探す」のボタンを作成
    renderShapeButtons() {
        this.steelCategorySet.varieties.forEach((variety, index) => {
            const isActive = index === 0 ? 'active' : '';
            const tabId = `shape-${variety.name}`;
            const $tabNav = $(
                `<button type="button" class="tab-button tab-button__steel-variety ${isActive}" data-tab="${tabId}" data-tab-group="shape">${variety.name}</button>`
            );
            $('.tab-nav.--shape').append($tabNav);
            const types = variety.types;
            const categories = types[0].categories;
            const $tabContent = $(`
                <div class="tab-content ${isActive}" id="${tabId}" data-variety="${variety.name}" data-tab-group="shape">
                <h3 class="shape-box--title title-sBold">形状</h3>
                <div class="shape-box--btn-group shape-box--btn-group__steel-type">
                    ${variety.types
                            .map((type, typeIndex) => {
                                return `<button type="button" class="shape-box--btn shape-box--btn__steel-type ${typeIndex === 0 ? 'active' : ''
                                    }" data-type="${type.name}">${type.name}</button>`;
                            })
                            .join('')}
                </div>
                <h3 class="shape-box--title title-sBold">鋼種</h3>
                <div class="shape-box--btn-group shape-box--btn-group__steel-category">
                    ${this.createCategoryButtons(categories)}
                </div>
                </div>
            `);
            $('.tab-contents.--shape').append($tabContent);
        });
        this.updCondSearchHiddenParams();
    }

    // 鋼種ボタンのDOMを生成
    createCategoryButtons(categories) {
        return `              
            ${categories
                ? categories.map((category, categoryIndex) => {
                    return `<button type="button" class="shape-box--btn shape-box--btn__steel-category ${categoryIndex === 0 ? 'active' : ''
                        }" data-category="${category.name}">${category.name}</button>`;
                }).join('')
                : ''
            }`;
    }

    // 「品種から探す」の隠しパラメータを更新
    updCondSearchHiddenParams() {
        const $activeTabContent = $('.tab-contents.--shape .tab-content.active');

        const activeVariety = $activeTabContent.data('variety');
        const activeType = $activeTabContent.find('.shape-box--btn__steel-type.active').data('type');
        const activeCategory = $activeTabContent.find('.shape-box--btn__steel-category.active').data('category');

        const $form = $('#form-cond-search');
        $form.find('input[name="steel_variety"]').val(activeVariety);
        $form.find('input[name="steel_type"]').val(activeType);
        $form.find('input[name="steel_category"]').val(activeCategory);
    }

    // 「品種から探す」の最初のタブ・ボタンを選択
    selectFirstShapeContent() {
        $('.tab-contents[data-tab-group="shape"] .tab-content').removeClass('active');
        $('.tab-nav[data-tab-group="shape"] .tab-button').removeClass('active');
        $('.tab-contents[data-tab-group="shape"] .tab-content:first').addClass('active');
        $('.tab-nav[data-tab-group="shape"] .tab-button:first').addClass('active');
    }

    // 現在アクティブな形状・鋼種を規定値にリセット）（active付け替え・鋼種ボタン群を更新）
    resetActiveShapeContent() {
        const $activeShapeContent = $('.tab-contents[data-tab-group="shape"] .tab-content.active');

        // 形状ボタンのactive付け替え
        const $activeSteelTypeGroup = $activeShapeContent.find('.shape-box--btn-group__steel-type');
        $activeSteelTypeGroup.find('.shape-box--btn').removeClass('active');
        $activeSteelTypeGroup.find('.shape-box--btn:first').addClass('active');

        // 形状に合わせて鋼種ボタン群を更新
        const $activeSteelTypeBtn = $activeShapeContent.find('.shape-box--btn__steel-type');
        this.selectSteelType($activeSteelTypeBtn);

        // 鋼種ボタンのactive付け替え
        const $activeSteelCategoryGroup = $activeShapeContent.find('.shape-box--btn-group__steel-category');
        $activeSteelCategoryGroup.find('.shape-box--btn').removeClass('active');
        $activeSteelCategoryGroup.find('.shape-box--btn:first').addClass('active');

        // 隠しパラメータを更新
        this.updCondSearchHiddenParams();
    }

    // 鋼種切り替え
    selectSteelType($steelTypeBtn) {
        const $tabContent = $steelTypeBtn.closest('.tab-content');
        const $steelCategoryGroup = $tabContent.find('.shape-box--btn-group__steel-category');

        const variety = $tabContent.data('variety');
        const type = $steelTypeBtn.data('type');
        const categories = this.steelCategorySet.varieties
            .find(v => v.name === variety)
            .types.find(t => t.name === type).categories;

        $steelCategoryGroup.empty();
        $steelCategoryGroup.append(this.createCategoryButtons(categories));

        // 隠しパラメータを更新
        this.updCondSearchHiddenParams();
    }

    /* レコメンド
    -------------------------------------------------------- */
    // おすすめの商品の高さを揃える(PC時のみ)
    adjustRecommendProductsHeight() {
        document.querySelectorAll('.standard-item__info .price').forEach(el => {
            el.style.marginTop = "";
        });

        if (window.innerWidth < 1025) return;

        const productsBoxs = document.querySelectorAll('.common-standard__collection');
        const firstGroup = [productsBoxs[0], productsBoxs[1]];
        const secondGroup = [productsBoxs[2], productsBoxs[3]];

        [firstGroup, secondGroup].forEach((group, groupIndex) => {
            const itemsA = group[0].querySelectorAll('.standard-item');
            const itemsB = group[1].querySelectorAll('.standard-item');

            itemsA.forEach((item, i) => {
                const heightA = item.offsetHeight;
                const heightB = itemsB[i]?.offsetHeight || 0;

                if (!itemsB[i]) return;

                if (heightA !== heightB) {
                    const differenceHeight = Math.abs(heightA - heightB);
                    const target = heightA > heightB ? itemsB[i] : item;
                    const itemMargin = target.querySelector('.standard-item__info .price');
                    if (itemMargin) itemMargin.style.marginTop = Math.floor(differenceHeight + 12) + "px";
                }
            });
        });
    }
}
